function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 12C13.3807 12 14.5 10.8807 14.5 9.5C14.5 8.11929 13.3807 7 12 7C10.6193 7 9.5 8.11929 9.5 9.5C9.5 10.8807 10.6193 12 12 12Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.83253 13.6039C2.49673 8.66195 6.03752 2 11.9999 2C17.9623 2 21.5031 8.66196 18.1673 13.6039L12.7797 21.5856C12.6047 21.8447 12.3125 22 11.9999 22C11.6873 22 11.3951 21.8447 11.2202 21.5856L5.83253 13.6039ZM16.5096 12.4849L12.4143 18.552C12.2161 18.8457 11.7837 18.8457 11.5855 18.552L7.49023 12.4849C5.05104 8.87132 7.64011 4 11.9999 4C16.3597 4 18.9488 8.87132 16.5096 12.4849Z"
});

var SvgLocation = function SvgLocation(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#18B6FF"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/location.a20bfa2f.svg";
export { SvgLocation as ReactComponent };